import {
    Container, Row, Col, Card, CardHeader, CardBody, ListGroup, ListGroupItem, Spinner
} from "reactstrap";
import SimpleHeader from "../../components/SimpleHeader/SimpleHeader";
import React, { useState, useEffect } from "react";
import { importLocation, exportLocation } from "../../utilities/orgPanelApiCalls";
import HTTPStatus from "../../components/Enums/HTTPStatus";
import { ToastMessage } from '../../components/ToastMessage/ToastMessage';
import { errorToast, successToast, warningToast } from '../../constants/toast';
import { useStore } from "../../utilities/appStore";
import ImportHistoryTable from "./ImportHistoryTable";
import {useGetImportHistoryQuery, key as importHistoryKey } from "../../utilities/queries/useGetImportHistoryQuery";
import { useQueryClient } from "@tanstack/react-query";
import Button from "../../components/UIButton/UIButton";

const ImportExportPage = () => {
    let currentOrganizationId = useStore((state) => state.CurrentOrganizationId);

    const onDownload = () => {
        const link = document.createElement("a");
        link.download = `Locations_ExportTemplate.xlsx`;
        link.href = "/Locations_ExportTemplate.xlsx";
        link.click();
    };

    const [selectedFile, setSelectedFile] = useState();
    const [selectedFileName, setSelectedFileName] = useState("No file selected");
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [hasErrors, setHasErrors] = useState(false);
    const [importErrors, setimportErrors] = useState([]);
    const [toast, SetToast] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isUploadLoading, setIsUploadLoading] = useState(false);
    const { data: historyData, error: getError, status: historyStatus } = useGetImportHistoryQuery();
    const [ pendingInHistory, setPendingInHistory ] = useState(true);
    const queryClient = useQueryClient();

    const forceRefetch = () => {
        queryClient.invalidateQueries({ queryKey: [importHistoryKey, currentOrganizationId] });
    };

    useEffect(() => {
        if (historyData) {
            const pendingImports = historyData.filter(history => history.isComplete === false);
            if (pendingImports.length === 0) { setPendingInHistory(false) }
        }
    }, [historyData]);

    const exportButtonDisabled = isLoading || !currentOrganizationId;

   

    const makeToast = (message, type) => {
        SetToast({
            display: true,
            message: message,
            type: type
        });
    }

    const toastToggleCallback = () => {
        SetToast({
            display: false,
            message: ""
        });
    }

    const onExport = async () => {
        setIsLoading(true);
        var result = await exportLocation(currentOrganizationId);
        setIsLoading(false);

        if (result?.status == HTTPStatus.Ok) {

            const url = window.URL
                .createObjectURL(new Blob([result.data]));
            const link = document.createElement("a");
            link.download = `Locations_Export.xlsx`;
            link.href = url;
            link.click();

            makeToast("Data Successfully Exported", successToast);
        }
        else {
            makeToast("Error during export", errorToast);
        }
    }

    const changeHandler = (event) => {
        setHasErrors(false);
        setSelectedFile(event.target.files[0]);
        setSelectedFileName(event.target.files[0].name);
        setIsFilePicked(true);
    };

    const handleSubmission = async () => {
        if (isFilePicked) {
            setIsUploadLoading(true);
            var result = await importLocation(currentOrganizationId, selectedFile);

            if (result?.status === HTTPStatus.BadRequest) {
                setHasErrors(true);
                setimportErrors(result?.data);
                makeToast("Validation issue during import", warningToast);
                forceRefetch();
                setIsUploadLoading(false);
            }
            else if (result?.status == HTTPStatus.Ok) {
                makeToast("Data Successfully Imported", successToast);
                setHasErrors(false);
                setimportErrors([]);
                forceRefetch();
                setIsUploadLoading(false);
            }
            else {
                makeToast("Error during import", errorToast);
                forceRefetch();
                setIsUploadLoading(false);
            }
        }
    };

    const ImportErrors = () => {
        if (hasErrors && importErrors) {
            return (
                <div>
                    <div className="h4 import-hdr-wrn">Errors found during import:</div>
                    {importErrors.map((item) => (
                        <Row key={item.rowNumber}>
                            <span className="import-validation-wrn">Row {item.rowNumber}: {item.errors.map((error) => {
                                return (<span key={error}>{error}</span>)
                            })}</span><br />
                        </Row>
                    ))}
                </div>
            );
        }
    }

    return (
        <>
            {toast?.display && (
                <ToastMessage Message={toast?.message} ToggleCallback={toastToggleCallback} Type={toast?.type} />

            )}
            <SimpleHeader name="Home" parentName="Import / Export" />
            <Container className="mt--6" fluid>
                <Row className="justify-content-center">
                    <Col className="card-wrapper">
                        <Card className="card-header-devices">
                            <CardHeader>
                                <h2 className="m-1">Import / Export</h2>
                            </CardHeader>
                            <Row>
                                <Col className="col-sm-6">
                                    <div className="import-card-white">
                                        <div className="import-hdr-txt">
                                            <div className="h4">Upload Location Data</div>
                                            <div className="export-spn-warning">Please check data carefully before upload. Any errors will cause this process to fail.</div></div>
                                        <CardBody className="w-50 align-self-center justify-content-start align-items-center">
                                            <Row className="mb-4 align-items-center">
                                                <Button
                                                    as="label"
                                                    htmlFor="fileInput"
                                                    variant="primary"
                                                    size="large"
                                                    className="mr-2"
                                                    width="150px"
                                                >
                                                    Choose File
                                                </Button>

                                                <span className="file-select-spn">{selectedFileName}</span>

                                                <input
                                                    type="file"
                                                    id="fileInput"
                                                    className="d-none"
                                                    name="file"
                                                    onChange={changeHandler}
                                                />
                                            </Row>

                                            <Row className="mb-4 align-items-center">
                                                <Button variant="primary" size="large" width="150px" disabled={!isFilePicked || pendingInHistory || isUploadLoading} onClick={handleSubmission} className="mr-2" id="uploadBtn" >
                                                    {isUploadLoading || historyStatus === 'pending' || pendingInHistory ? <Spinner /> : "Upload"}</Button>
                                                    {historyStatus === 'pending' && <span>Loading import history</span>}
                                                    {historyStatus === 'success' && pendingInHistory && <span className="file-select-spn">Import Pending</span> }
                                            </Row>
                                        </CardBody>
                                    </div>
                                    <CardBody className="card-body-gray">
                                        <div className="h4 export-dwn-hdr">Download Template Files</div>
                                        <div className="import-btn-container">
                                            <Row>
                                                <Button className="mr-2" variant="primary" size="small" onClick={onExport} id="exportBtn" disabled={exportButtonDisabled}>
                                                    {isLoading ? <Spinner size="sm" /> : "Export Data"}
                                                </Button>
                                            </Row>
                                            <Row>
                                                <span className="export-spn-info">This file includes all existing locations and hierarchy assignments.</span>
                                            </Row>
                                            <Row>
                                                <Button className="mr-2" variant="primary" size="small" onClick={onDownload} id="downloadTemplateBtn">
                                                    Blank Template
                                                </Button>
                                            </Row>
                                            <Row>
                                                <span className="export-spn-info">This file has no existing data, so you are starting from scratch.</span>
                                            </Row>
                                        </div>
                                    </CardBody>
                                </Col>
                                <Col className="col-sm-6 import-error-col">
                                    <CardBody className="w-50 align-self-center justify-content-start align-items-center">
                                        <ImportErrors />
                                    </CardBody>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="import-history-wrapper">
                                    <h3 className="m-4">Import History</h3>
                                    {historyData &&
                                        <ImportHistoryTable data={historyData} />
                                    }
                                    {historyStatus === 'pending' && <Spinner></Spinner> }
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default ImportExportPage;
